'use strict';

/*global initialize*/
/*global blockElement*/
/*global unBlockElement*/
/*global services*/
/*global compareTimes*/
/*global hoursBetweenTimes*/
/*global roundToDecimals*/
/*global isEmpty*/
/*global createObjectCallBack*/
function ProjectTimesheet() {

  this.init();
}

ProjectTimesheet.prototype = $.extend({}, {
  constructor: 'ProjectTimesheet',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.project-time-sheet', function () {
      _this.showEditForm($(this).data('timesheet_rid'), $(this).data('date'), 0, $(this).data('job_queue_rid'), $(this).data('spo_rid'), $(this).data('from_timesheet_rid'), $(this).data('callback'));
      return false;
    });

    $('body').on('click', '.project-time-sheet-quick', function () {
      _this.showQuickForm($(this).data('project_rid'), $(this).data('superior_rid'), $(this).data('callback'));
      return false;
    });

    $('body').on('click', '.project-time-sheet-unconfirm', function () {
      _this.unconfirmAndTimesheet($(this), $(this).data('timesheet_rid'), $(this).data('callback'));
      return false;
    });

    $('body').on('change', '.modal .increase-billing, .modal .quantity', function () {
      _this.increaseBilling();
      return false;
    });

    $('body').on('change', '.modal .timesheet-type :radio', function () {
      _this.toggleIncreaseBilling();
    });

    $('body').on('changeLookup', '.timesheet-project .lookup', function () {
      _this.changeProject();
    });

    $('body').on('changeLookup', '.timesheet-spo-resource .lookup', function () {
      _this.changeProjectSPO();
    });
  },

  //----------------------------------------------------------------------------

  reloadTimesheetSpoResourceInfo: function (spoResourceRID) {
    var _this = this;

    var modal = services.get('modal');

    var $spoResourceInfo = modal.contentDOM().find('.timesheet-spo-resource-info');
    blockElement($spoResourceInfo);
    $.get(services.get('router').path('project_timesheet_spo_resource_info', { spoResourceRID: spoResourceRID ? spoResourceRID : -1 }), function (res) {
      unBlockElement($spoResourceInfo);
      $spoResourceInfo.html(res.data.html);
    });

    return _this;
  },

  changeProject: function () {
    var _this = this;

    var modal = services.get('modal');

    var $form = modal.contentDOM().find('form');
    var $projectLookup = modal.contentDOM().find('.timesheet-project .lookup');

    var projectPlan = $projectLookup.data('field_datefrom_p') + ' - ' + $projectLookup.data('field_dateto_p');
    var customerLogoCalc = $projectLookup.data('field_customerlogocalc');

    $form.find('.timesheet-project-plan').text(projectPlan);
    $form.find('#project-timesheet-customer-logo').attr('src', 'https://portal.k2ol.cz/media/' + customerLogoCalc);

    var $projectSPOInput = $form.find('.project-stage-planned-operation-superior').find('input');
    var $projectSPOResourceInput = $form.find('.timesheet-spo-resource').find('input');

    $projectSPOInput.val('');
    $projectSPOInput.focus().keyup();

    $projectSPOResourceInput.val('');
    $projectSPOResourceInput.focus().keyup();

    return _this;
  },

  changeProjectSPO: function () {
    var _this = this;

    var modal = services.get('modal');

    var $form = modal.contentDOM().find('form');
    var $spoResourceLookup = modal.contentDOM().find('.timesheet-spo-resource .lookup');

    var bill = $spoResourceLookup.data('field_masterrid_cf_bill');
    var typeOfBilling = $spoResourceLookup.data('field_masterrid_cf_typeofbilling');
    var statusId = $spoResourceLookup.data('field_status_id');
    var spoResourceCFTimeOP = $spoResourceLookup.data('field_cftime_op');
    var spoCFTimeOP = $spoResourceLookup.data('field_masterrid_cftime_op');

    //pokud je to nefakturacni tak skryjeme zbytecne pole
    var $notBillHidden = $form.find('.not-bill-hidden');
    if (bill) {
      $notBillHidden.show();
    } else {
      $notBillHidden.hide();
    }

    //pokud je to fixed time, tak zakazeme a skryjeme
    var $fixedTimeFixedPriceDisabled = $form.find('.fixed-time-fixed-price-disabled');
    var $fixedTimeFixedPriceHidden = $form.find('.fixed-time-fixed-price-hidden');
    if (parseInt(typeOfBilling) === parseInt(services.get('configurations').param('FixedTimeFixedPrice'))) {
      $fixedTimeFixedPriceDisabled.attr('disabled', true);
      $fixedTimeFixedPriceHidden.hide();
    } else {
      $fixedTimeFixedPriceDisabled.removeAttr('disabled');
      $fixedTimeFixedPriceHidden.show();
    }

    //nastavime status
    var $projectSPOResourceStatusWrapper = $form.find('.project-spo-resource-status-wrapper');
    var $statusRadio = $projectSPOResourceStatusWrapper.find('input:radio[value="' + statusId + '"]');
    if (!$statusRadio.is(':checked')) {
      $statusRadio.click();
    }

    //upravime fakturacni casy
    $form.find('.billing-time').val(spoResourceCFTimeOP);
    $form.find('.billing-time-orig').val(spoResourceCFTimeOP);
    $form.find('.project-spo-billing-time').val(spoCFTimeOP);

    _this.reloadTimesheetSpoResourceInfo($spoResourceLookup.find('input[data-lookup-field="id"]').val());

    return _this;
  },

  toggleIncreaseBilling: function () {
    var _this = this;

    var modal = services.get('modal');
    var timesheetType = modal.contentDOM().find('.timesheet-type input:radio:checked').val();

    if (timesheetType === '1') {
      //efektivni
      modal.contentDOM().find('.increase-billing').attr('checked', true).change();
    } else {
      //neefektivni
      modal.contentDOM().find('.increase-billing').removeAttr('checked').change();
    }

    return _this;
  },

  increaseBilling: function () {
    var _this = this;

    var modal = services.get('modal');
    var quantity = !isEmpty(modal.contentDOM().find('.quantity').val()) ? parseFloat(modal.contentDOM().find('.quantity').val().replace(',', '.')) : 0;
    var $billingTimeInput = modal.contentDOM().find('.billing-time');
    var $billingTimeOrigInput = modal.contentDOM().find('.billing-time-orig');
    var billingTime = !isEmpty($billingTimeOrigInput.val()) ? parseFloat($billingTimeOrigInput.val()) : 0;

    if (modal.contentDOM().find('.increase-billing').is(':checked') && !$billingTimeInput.is(':disabled') && $billingTimeInput.is(':visible')) {
      $billingTimeInput.val(quantity + billingTime);
    } else {
      $billingTimeInput.val(billingTime);
    }

    return _this;
  },

  validateTime: function validateTime($form) {
    var $timeFrom = $form.find('.time-from');
    var $timeTo = $form.find('.time-to');

    $timeFrom.parent().removeClass('has-error');
    if (!isEmpty($timeFrom.val()) && !isEmpty($timeTo.val())) {
      if (compareTimes($timeFrom.val(), $timeTo.val()) > 0) {
        return true;
      } else {
        $timeFrom.parent().addClass('has-error');
      }
    }

    return false;
  },

  countTotalTime: function countTotalTime($form) {
    var _this = this;

    var $timeFrom = $form.find('.time-from');
    var $timeTo = $form.find('.time-to');

    if (!isEmpty($timeFrom.val()) && !isEmpty($timeTo.val())) {
      $form.find('.quantity').val(roundToDecimals(hoursBetweenTimes($timeFrom.val(), $timeTo.val()), 3)).change();
    }

    return _this;
  },

  replaceProjectRID: function replaceProjectRID($btn, projectRID) {
    var _this = this;

    if ($btn) {
      var href = $btn.data('href');
      if (!isEmpty(href) && !isEmpty(projectRID)) {
        href = href.replace('%ProjectRID%', projectRID);
      }

      $btn.attr('href', href);
    }

    return _this;
  },

  initForm: function initForm() {
    var _this = this;

    var modal = services.get('modal');
    initialize(modal.contentDOM());

    modal.contentDOM().find('.time-from, .time-to').on('change', function () {
      if (_this.validateTime(modal.contentDOM())) {
        _this.countTotalTime(modal.contentDOM());
      }
    });

    var $projectRIDInput = modal.contentDOM().find('.timesheet-project input[data-lookup-field="id"]');

    var $spoResourceBtn = modal.contentDOM().find('.timesheet-spo-resource').find('.btn');
    $spoResourceBtn.data('href', $spoResourceBtn.attr('href'));
    _this.replaceProjectRID($spoResourceBtn, $projectRIDInput.val());

    var $superiorBtn = modal.contentDOM().find('.project-stage-planned-operation-superior').find('.btn');
    $superiorBtn.data('href', $superiorBtn.attr('href'));
    _this.replaceProjectRID($superiorBtn, $projectRIDInput.val());

    $projectRIDInput.on('changeLookupValue', function () {
      var value = $(this).val();
      _this.replaceProjectRID($spoResourceBtn, value);
      _this.replaceProjectRID($superiorBtn, value);
    });

    if (!isEmpty($projectRIDInput.val())) {
      //nastavime timeout, nekdy to blbne pokud je to hned po otevreni
      setTimeout(function () {
        modal.contentDOM().find('.quantity').focus();
      }, 300);
    }

    var timer = services.get('timers').addTimer('timesheet', { $container: modal.contentDOM().find('.timer-time') });
    timer.startTimer();

    return _this;
  },

  closeForm: function closeForm() {
    var _this = this;

    services.get('timers').getTimer('timesheet').stopTimer();

    return _this;
  },

  submitForm: function submitForm(params) {
    var _this = this;

    var modal = services.get('modal');
    var $content = modal.contentDOM();
    var $form = $content.find('form');

    var date = $form.find('.timesheet-date').val();

    modal.block();
    $.post($form.attr('action'), $form.serialize(), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.close();
        services.get('notifications').viewSaveMessage();

        if (('callBack' in params) && !isEmpty(params.callBack) && (params.callBack in window)) {
          window[params.callBack]();
        } else {
          if (services.has('dashboard')) {
            services.get('dashboard').invalidWidgetsByTag('timesheets', '&date=' + date);
            services.get('dashboard').invalidWidgetsByTag('job_queue');
          }
        }
      } else if (res.msg === 'NOT_VALID') {
        modal.content(res.data.html);
        _this.initForm();
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  showEditForm: function showEditForm(timeSheetRID, date, quantity, jobQueueRID, spoRID, fromTimeSheetRID, callBack) {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('project_timesheet.title'),
      height: 'auto',
      minHeight: '300px',
      submitCallBack: createObjectCallBack(_this, 'submitForm', { callBack: callBack }),
      closeCallBack: createObjectCallBack(_this, 'closeForm'),
      width: 'lg',
      form: true,
      modalClass: 'project-timesheet-form',
      keyboardClose: false
    });

    modal.block();
    $.get(services.get('router').path('project_timesheet'), { RID: timeSheetRID, Date: date, Quantity: quantity, JobQueueRID: jobQueueRID, SPORID: spoRID, TimeSheetRID: fromTimeSheetRID }, function (res) {
      modal.unBlock();
      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
        _this.initForm();
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  showQuickForm: function showQuickForm(projectRID, superiorRID, callBack) {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('project_timesheet.quick'),
      height: 'auto',
      minHeight: '300px',
      submitCallBack: createObjectCallBack(_this, 'submitForm', { callBack: callBack }),
      closeCallBack: createObjectCallBack(_this, 'closeForm'),
      width: 'lg',
      form: true,
      modalClass: 'project-timesheet-form',
      keyboardClose: false
    });

    modal.block();
    $.get(services.get('router').path('project_timesheet_quick'), { ProjectRID: projectRID, SuperiorRID: superiorRID }, function (res) {
      modal.unBlock();
      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
        _this.initForm();
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  unconfirmAndTimesheet: function unconfirmAndTimesheet($wrapper, timeSheetRID, callBack) {
    var _this = this;

    blockElement($wrapper);
    $.get(services.get('router').path('project_timesheet_unconfirm', { timeSheetRID: timeSheetRID }), function (res) {
      unBlockElement($wrapper);

      if (res.msg === 'SUCCESS') {
        _this.showEditForm(timeSheetRID, null, null, null, null, null, callBack);
        if (services.has('dashboard')) {
          services.get('dashboard').invalidWidgetsByTag('timesheets');
          services.get('dashboard').invalidWidgetsByTag('job_queue');
        }
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
